import React from 'react';

const OtherBannerNew = () => (
  <div className="flex w-36 max-w-[190px] whitespace-nowrap py-2.5 px-4 bg-primary text-white text-md font-sourcesans rounded-lg">
    <p>Listed by Agent</p>
  </div>
);

export default OtherBannerNew;
